import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum PaperSizeId {
  A4 = 1,
  A5 = 2,
  CHIT_80 = 3,
}

export class PaperSize extends Codebook<PaperSizeId> {
  private constructor(
    public readonly value: PaperSizeId,
    public readonly label: () => string,
  ) {
    super(value)
  }

  static readonly A4 = new PaperSize(PaperSizeId.A4, () => $t('A4'))
  static readonly A5 = new PaperSize(PaperSizeId.A5, () => $t('A5'))
  static readonly CHIT_80 = new PaperSize(PaperSizeId.CHIT_80, () => $t('Chit (80mm)'))
}
